export default "__VITE_ASSET__BcEcH$EJ__"